<template>
  <Panel header="Đăng ký tài khoản">
    <div class="grid grid-cols-1 gap-4 md:grid-cols-12 mb-8">
      <div class="flex min-w-0 flex-col md:col-span-3">
        <label>Tên đăng nhập</label>
        <InputText id="username" type="text" v-model="register.username" />
      </div>
      <div class="flex min-w-0 flex-col md:col-span-3">
        <label>Mật khẩu(tối thiểu 6 ký tự)</label>
        <Password
          id="password"
          v-model="register.password"
          toggleMask
          :feedback="true"
        />
      </div>
      <div class="flex min-w-0 flex-col md:col-span-3">
        <label>Họ và tên</label>
        <InputText id="fullname" type="text" v-model="register.fullname" />
      </div>
      <div class="flex min-w-0 flex-col md:col-span-3">
        <label>Số điện thoại</label>
        <InputText
          id="phoneNumber"
          type="text"
          v-model="register.phoneNumber"
        />
      </div>
      <div class="flex min-w-0 flex-col md:col-span-3">
        <label>Chọn quyền hạn</label>
        <Dropdown
          id="permission"
          v-model="register.permission"
          :options="userPermission"
          optionLabel="label"
          optionValue="value"
          placeholder="Vui lòng chọn quyền hạn của tài khoản ..."
          @change="selectPermission"
        >
        </Dropdown>
      </div>
      <div
        class="flex min-w-0 flex-col md:col-span-3"
        v-if="register.permission == 'civilGroup'"
      >
        <label>Chọn tổ</label>
        <Dropdown
          id="civilGroup"
          v-model="civilGroup"
          :options="listCivilGroup"
          optionLabel="civilGroupName"
          placeholder="Vui lòng chọn tổ ..."
          :filter="true"
        >
        </Dropdown>
      </div>
    </div>
    <Button
      v-if="valid"
      label="Đăng ký"
      icon="pi pi-plus-circle"
      iconPos="left"
      @click="doRegister()"
    />
    <Button
      v-else
      label="Đăng ký"
      icon="pi pi-plus-circle"
      iconPos="left"
      disabled="disabled"
    />
  </Panel>
</template>

<script lang="ts">
import { computed, ref } from "vue";
import AuthRepository from "@/services/AuthRepository";
import { useToast } from "@/ui/services/toast";
import { useRouter } from "vue-router";
import { Register } from "../models/register";
import { useStore } from "vuex";
import TeamRepository from "../services/TeamRepository";
import { Team } from "@/models/team.models";
import Ward from "@/models/Ward.models";
import CivilGroup from "@/models/CivilGroup.models";
import zaloRepository from "@/services/ZaloRepository";

export default {
  setup() {
    const router = useRouter();
    const register = ref({} as Register);
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const listWard = ref([] as Ward[]);
    const listCivilGroup = ref([] as CivilGroup[]);
    const ward = ref({} as Ward);
    const civilGroup = ref({} as CivilGroup);

    const valid = computed(() => {
      console.log(
        "$$$$$$$############### debug permission: " + register.value.permission,
      );
      if (register.value.permission == "civilGroup") {
        return (
          register.value.fullname &&
          register.value.username &&
          register.value.password &&
          register.value.phoneNumber &&
          civilGroup.value.id
        );
      } else if (register.value.permission == "ward") {
        return (
          register.value.fullname &&
          register.value.username &&
          register.value.password &&
          register.value.phoneNumber
        );
      } else if (register.value.permission == "admin") {
        return (
          register.value.fullname &&
          register.value.username &&
          register.value.password &&
          register.value.phoneNumber
        );
      }
    });

    if (!(store.state.permission == "admin")) {
      router.push({
        name: "home",
      });
    }
    const teams = ref({} as Team[]);

    register.value.permission = "";
    const userPermission = ref([
      { label: "Tài khoản cấp tổ", value: "civilGroup" },
      // { label: 'Tài khoản cấp phường', value: 'ward' },
      // { label: 'Tài khoản cấp quận', value: 'district' },
      { label: "Quản lý", value: "admin" },
    ]);

    TeamRepository.getTeams()
      .then((response) => {
        teams.value = response.data;
      })
      .catch();

    const doRegister = () => {
      if (register.value.password.length < 6) {
        toast.add({
          severity: "error",
          summary: "Thất bại",
          detail: "Mật khẩu không hợp lệ, vui lòng nhập lại mật khẩu",
          life: 2000,
        });
      } else {
        if (ward.value != null) {
          register.value.idWard = ward.value.id;
        }
        if (civilGroup.value != null) {
          register.value.idWard = ward.value.id;
          register.value.idCivilGroup = civilGroup.value.id;
        }
        AuthRepository.registerUser(register.value)
          .then((response) => {
            toast.add({
              severity: "success",
              summary: "Đăng ký",
              detail: "Đăng ký thành viên thành công vào hệ thống",
              life: 2000,
            });
            // router.push({
            //   name: 'home'
            // });
          })
          .catch((err) => {
            toast.add({
              severity: "error",
              summary: "Lỗi",
              detail: err.response.data,
              life: 2000,
            });
          });
      }
    };

    // const selectPermission = () => {
    //   listWard.value = [];
    //   listCivilGroup.value = [];
    //   if((register.value.permission == "civilGroup")||(register.value.permission == "ward"))
    //   {
    //     zaloRepository.getListWard()
    //         .then((response) => {
    //           listWard.value = response.data;
    //         })
    //         .catch(err => {
    //           toast.add({
    //             severity: 'error',
    //             summary: 'Lỗi',
    //             detail:err.response.data,
    //             life: 2000
    //           });
    //         });
    //   }
    // };
    // const selectWard = () => {
    //   listCivilGroup.value = [];
    //   // if((register.value.permission == "civilGroup"))
    //   {
    zaloRepository
      .getListCivilGroup()
      .then((response) => {
        listCivilGroup.value = response.data;
      })
      .catch((err) => {
        toast.add({
          severity: "error",
          summary: "Lỗi",
          detail: err.response.data,
          life: 2000,
        });
      });
    //   }
    // };
    // selectWard();

    return {
      register,
      doRegister,
      valid,
      teams,
      userPermission,
      error,
      // selectPermission,
      civilGroup,
      ward,
      listCivilGroup,
      listWard,
      // selectWard,
    };
  },
};
</script>
